export default __webpack_public_path__ + "static/media/about-img.b1ef26ff.jpg";